"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ScalableSolid: function() {
        return ScalableSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ScalableSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 3C7 1.89543 7.89543 1 9 1H21C22.1046 1 23 1.89543 23 3V15C23 16.1046 22.1046 17 21 17H11V21C11 22.1046 10.1046 23 9 23H3C1.89543 23 1 22.1046 1 21V15C1 13.8954 1.89543 13 3 13H7V3ZM13 5C12.4477 5 12 5.44772 12 6C12 6.55228 12.4477 7 13 7H15.5858L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L17 8.41421V11C17 11.5523 17.4477 12 18 12C18.5523 12 19 11.5523 19 11V6C19 5.44772 18.5523 5 18 5H13Z",
        fill: "currentColor"
    })
}), "ScalableSolid");
const _default = ScalableSolid;
